var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon60StationsWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-60-stations-white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119.497,
    height: 119.54,
    viewBox: "0 0 119.497 119.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.044,
    x2: 1.04,
    y2: 1.019,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#098caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09d785"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2359",
    "data-name": "Caminho 2359",
    d: "M29.855,114.207v0c0-1.915.7-2.636,2.6-2.64q5.685-.01,11.363,0H86.148c3.169,0,3.763.673,3.394,3.934H29.855Zm11.7-7.775v-.005a27.748,27.748,0,0,0,5.608-10.012.867.867,0,0,1,.97-.75l.031,0c7.721.018,15.436.006,23.154.034a1.131,1.131,0,0,1,.893.509,29.968,29.968,0,0,0,6.284,10.9,3.418,3.418,0,0,1,.241.454H40.656c.378-.478.632-.812.9-1.135M10.386,91.665c-3.376,0-5.9-2.017-6.35-5.053a8.666,8.666,0,0,1-.06-1.223c-.006-1.852,0-3.705,0-5.639H115.443a68.705,68.705,0,0,1-.048,6.958,5.749,5.749,0,0,1-5.836,4.952c-2.934.033-5.868.008-8.8.008H10.386ZM3.973,74.486V10.4C3.973,6.459,6.427,4,10.363,4Q59.784,4,109.2,4a5.908,5.908,0,0,1,6.305,6.257q.013,32.158,0,64.315v1.111H3.973ZM108.481,0Q75.2.053,41.915.031H9.735A9.842,9.842,0,0,0,.005,9.774Q0,21.381,0,33v5.939Q0,62.368.011,85.8a8.053,8.053,0,0,0,.137,1.658,9.97,9.97,0,0,0,10.173,8.217q15.77.01,31.54,0h1.42c-.242.637-.409,1.123-.608,1.594a33.446,33.446,0,0,1-5.663,8.347c-1.284,1.527-2.678,2.347-4.68,2a3.911,3.911,0,0,0-1,.032,5.934,5.934,0,0,0-5.446,5.873c-.017,1.077,0,2.155,0,3.233,0,2.216.561,2.786,2.735,2.786H91.137c1.806,0,2.461-.668,2.47-2.492,0-1.188.018-2.376,0-3.564a5.909,5.909,0,0,0-5.487-5.827c-.463-.036-.928-.033-1.394-.031-.5,0-1,.005-1.5-.04a2.016,2.016,0,0,1-1.249-.521c-1.758-2.009-3.573-3.988-5.131-6.145a46.47,46.47,0,0,1-2.857-5.242h11.1q11.228.005,22.457-.012a9.919,9.919,0,0,0,9.939-9.9v-.014q.008-20.346.009-40.692V29.693q0-9.925,0-19.85a9.3,9.3,0,0,0-1.7-5.438C115.545,1.188,112.407,0,108.533,0Z",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2360",
    "data-name": "Caminho 2360",
    d: "M29.855,114.207v0c0-1.915.7-2.636,2.6-2.64q5.685-.01,11.363,0H86.148c3.169,0,3.763.673,3.394,3.934H29.855Zm11.7-7.775v-.005a27.748,27.748,0,0,0,5.608-10.012.867.867,0,0,1,.97-.75l.031,0c7.721.018,15.436.006,23.154.034a1.131,1.131,0,0,1,.893.509,29.968,29.968,0,0,0,6.284,10.9,3.418,3.418,0,0,1,.241.454H40.656c.378-.478.632-.812.9-1.135M10.386,91.665c-3.376,0-5.9-2.017-6.35-5.053a8.666,8.666,0,0,1-.06-1.223c-.006-1.852,0-3.705,0-5.639H115.443a68.705,68.705,0,0,1-.048,6.958,5.749,5.749,0,0,1-5.836,4.952c-2.934.033-5.868.008-8.8.008H10.386ZM3.973,74.486V10.4C3.973,6.459,6.427,4,10.363,4Q59.784,4,109.2,4a5.908,5.908,0,0,1,6.305,6.257q.013,32.158,0,64.315v1.111H3.973ZM108.481,0Q75.2.053,41.915.031H9.735A9.842,9.842,0,0,0,.005,9.774Q0,21.381,0,33v5.939Q0,62.368.011,85.8a8.053,8.053,0,0,0,.137,1.658,9.97,9.97,0,0,0,10.173,8.217q15.77.01,31.54,0h1.42c-.242.637-.409,1.123-.608,1.594a33.446,33.446,0,0,1-5.663,8.347c-1.284,1.527-2.678,2.347-4.68,2a3.911,3.911,0,0,0-1,.032,5.934,5.934,0,0,0-5.446,5.873c-.017,1.077,0,2.155,0,3.233,0,2.216.561,2.786,2.735,2.786H91.137c1.806,0,2.461-.668,2.47-2.492,0-1.188.018-2.376,0-3.564a5.909,5.909,0,0,0-5.487-5.827c-.463-.036-.928-.033-1.394-.031-.5,0-1,.005-1.5-.04a2.016,2.016,0,0,1-1.249-.521c-1.758-2.009-3.573-3.988-5.131-6.145a46.47,46.47,0,0,1-2.857-5.242h11.1q11.228.005,22.457-.012a9.919,9.919,0,0,0,9.939-9.9v-.014q0-8.549.006-17.1V9.614a9.294,9.294,0,0,0-1.7-5.209C115.545,1.188,112.407,0,108.533,0Z",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2361",
    "data-name": "Caminho 2361",
    d: "M70.047,98.642a2.009,2.009,0,0,0-1.972,2,1.984,1.984,0,1,0,3.967-.025,2.007,2.007,0,0,0-1.983-1.979Z",
    transform: "translate(-68.075 -98.642)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2362",
    "data-name": "Caminho 2362",
    d: "M70.047,98.642a2.009,2.009,0,0,0-1.972,2,1.985,1.985,0,0,0,1.792,1.963h.384a1.985,1.985,0,0,0,1.792-1.987,2.007,2.007,0,0,0-1.983-1.979Z",
    transform: "translate(-68.075 -98.642)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2363",
    "data-name": "Caminho 2363",
    d: "M104.653,51.759c3.119,0,4.781-1.676,4.785-4.819,0-2.622-.016-5.244.007-7.865a4.267,4.267,0,0,1,3.178-4.3c.26-.071.532-.094.926-.16-.589,4.72-1.157,9.281-1.728,13.841-.188,1.493-.361,2.989-.578,4.478a1.774,1.774,0,0,1-1.716,1.652c-4.653.028-9.308.014-13.971.014a4,4,0,0,1,3.909-2.835c1.145-.014,2.292-.012,3.438-.008l1.43,0h.321M99.422,26.038a4.266,4.266,0,0,1-4.247-4.106c-.036-1.088-.043-2.178,0-3.265a4.273,4.273,0,0,1,8.538.055c.02.529,0,1.061,0,1.59s.015,1.061,0,1.59a4.255,4.255,0,0,1-4.263,4.135h-.031M92.488,17.5a25.644,25.644,0,0,0-.169,4.169,6.982,6.982,0,0,0,2.854,5.779c.147.115.278.246.443.393a9.109,9.109,0,0,0-3.326,7.725c.086,3.654.02,7.312.02,10.968v.9h2.852V46.5q0-5.86,0-11.722a5.691,5.691,0,0,1,1.613-4.094,16.652,16.652,0,0,1,1.285-1.068V44.564h2.827V28.992a5.5,5.5,0,0,1,5.668,5.372c.063,4.324.031,8.651.02,12.977,0,1.053-.545,1.555-1.635,1.563s-2.208.008-3.312.006l-1.712,0c-4.584,0-7.6,3.015-7.6,7.6q-.006,7.87,0,15.741v.886H95.2V57.472h.732c3.433,0,6.866.019,10.3-.018.635-.007.847.239,1.028.788,1.593,4.842,3.215,9.676,4.829,14.512.094.281.2.557.32.891.942-.316,1.8-.6,2.69-.9-1.709-5.128-3.388-10.167-5.051-15.155.064-.1.076-.133.1-.14.21-.069.427-.124.636-.2a4.6,4.6,0,0,0,3.288-3.866c.667-4.946,1.246-9.905,1.875-14.857.193-1.512.437-3.019.658-4.528v-1.34c-.389-.284-.757-.772-1.171-.815a8,8,0,0,0-5.4.994c-.2.127-.409.232-.679.384a8.869,8.869,0,0,0-4.88-6.406c1.938-1.885,2.252-4.215,2.118-6.683-.027-.5,0-1-.017-1.506a7.118,7.118,0,0,0-6.634-6.857q-.281-.024-.562-.025a7.06,7.06,0,0,0-6.884,5.76",
    transform: "translate(-92.286 -11.744)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2364",
    "data-name": "Caminho 2364",
    d: "M27.269,54.611a1.877,1.877,0,0,1-2.038-1.786c-.456-3.481-.886-6.968-1.323-10.452q-.479-3.807-.95-7.613a3.947,3.947,0,0,1,3.954,3.179,7.675,7.675,0,0,1,.131,1.5c.014,2.595,0,5.188.009,7.782a4.257,4.257,0,0,0,4.558,4.541c.721,0,1.443,0,2.166,0,1.09,0,2.181-.007,3.273.008a4.133,4.133,0,0,1,3.929,2.848H29.193c-.385,0-.77,0-1.155,0-.256,0-.513,0-.77-.008m9.746-28.574a4.251,4.251,0,0,1-4.242-4.1c-.018-.529,0-1.06,0-1.59l-.082-.007a17.068,17.068,0,0,1,.272-2.647A4.2,4.2,0,0,1,37.4,14.622a4.282,4.282,0,0,1,3.912,4.012,34.03,34.03,0,0,1,0,3.431,4.255,4.255,0,0,1-4.257,3.972h-.031m-6.859-8.806c-.53,3.321-.891,6.767,1.681,9.427a23.119,23.119,0,0,0-3,2.805,23.975,23.975,0,0,0-1.92,3.678,7.884,7.884,0,0,0-5.446-1.366,1.443,1.443,0,0,0-1.556,1.789c.822,6.614,1.632,13.229,2.5,19.835a4.594,4.594,0,0,0,3.3,3.855c.23.081.465.147.752.238L21.4,72.755l2.707.87c.08-.24.123-.37.167-.5,1.659-4.966,3.329-9.93,4.964-14.9a.915.915,0,0,1,1.044-.765c3.4.031,6.809.015,10.214.015h.867V73.126h2.816c0-5.7.017-11.339-.005-16.974a7.121,7.121,0,0,0-7.281-7.244c-.861-.006-1.722,0-2.583,0-.926,0-1.851,0-2.775,0-1.084-.008-1.618-.516-1.62-1.577-.01-4.3-.028-8.6.012-12.893A5.555,5.555,0,0,1,33.8,29.206a14.565,14.565,0,0,1,1.862-.333V44.558H38.5V29.791a5.527,5.527,0,0,1,2.821,5c.011,3.906,0,7.814,0,11.72v.916h2.853v-.977c0-3.6-.068-7.2.02-10.8a9.18,9.18,0,0,0-3.368-7.837,7.522,7.522,0,0,0,3.353-7.149c-.038-.668,0-1.34-.014-2.008a7.156,7.156,0,0,0-6.533-6.878,6.546,6.546,0,0,0-.694-.037,6.89,6.89,0,0,0-6.784,5.493",
    transform: "translate(-19.899 -11.738)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2365",
    "data-name": "Caminho 2365",
    d: "M51.945,47.2v2.819H66.212V78.516h2.864V49.961H83.31V47.2Z",
    transform: "translate(-51.945 -47.202)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2366",
    "data-name": "Caminho 2366",
    d: "M50.3,55.6v2.789c.842,0,1.62,0,2.4,0a4.293,4.293,0,0,1,4.653,4.628c.009,2.986.079,5.973-.026,8.956a6.077,6.077,0,0,0,1.364,4.568,1.716,1.716,0,0,1,.188.384H54.487V62.744H51.723a1.191,1.191,0,0,0-.073.24c-.005,5.105-.017,10.211,0,15.317a1.423,1.423,0,0,0,1.606,1.52c2.707.012,5.413.041,8.118-.027a2.282,2.282,0,0,0,1.467-.707c.449-.5.234-1.143-.143-1.7-.707-1.036-1.425-2.068-2.075-3.139a2.7,2.7,0,0,1-.4-1.307c-.034-3.459-.018-6.919-.026-10.379A6.842,6.842,0,0,0,58.7,58.307c-1.734-2.24-4-2.8-6.466-2.8-.637,0-1.286.037-1.942.092",
    transform: "translate(-50.296 -55.51)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2367",
    "data-name": "Caminho 2367",
    d: "M85.8,55.544a7.124,7.124,0,0,0-7.459,7.4,61.878,61.878,0,0,0,.035,6.274,9.923,9.923,0,0,1-2.447,8.073c-.018.02-.029.048-.045.07a1.482,1.482,0,0,0,1.322,2.48c1.73-.008,3.462-.007,5.193-.006h2.507c1.56,0,2-.435,2-1.977q0-7.114,0-14.228v-.865h-2.87V76.932H79.633a9.255,9.255,0,0,1,.622-.97,4.4,4.4,0,0,0,.966-3.1c-.061-3.263-.026-6.529-.02-9.792A4.3,4.3,0,0,1,85.889,58.4h2.377V55.544H85.8",
    transform: "translate(-75.487 -55.543)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5003",
    "data-name": "Grupo 5003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5002",
    "data-name": "Grupo 5002",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2294",
    "data-name": "Ret\\xE2ngulo 2294",
    width: 119.512,
    height: 119.54,
    transform: "translate(-0.001)",
    fill: "url(#linear-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5005",
    "data-name": "Grupo 5005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5004",
    "data-name": "Grupo 5004",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2295",
    "data-name": "Ret\\xE2ngulo 2295",
    width: 119.495,
    height: 119.54,
    transform: "translate(-0.001)",
    fill: "url(#linear-gradient)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5007",
    "data-name": "Grupo 5007",
    transform: "translate(57.76 83.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5006",
    "data-name": "Grupo 5006",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2296",
    "data-name": "Ret\\xE2ngulo 2296",
    width: 3.974,
    height: 3.983,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5009",
    "data-name": "Grupo 5009",
    transform: "translate(57.76 83.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5008",
    "data-name": "Grupo 5008",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2297",
    "data-name": "Ret\\xE2ngulo 2297",
    width: 3.973,
    height: 3.967,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5011",
    "data-name": "Grupo 5011",
    transform: "translate(78.303 9.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5010",
    "data-name": "Grupo 5010",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2298",
    "data-name": "Ret\\xE2ngulo 2298",
    width: 24.379,
    height: 61.902,
    transform: "translate(-0.068 0)",
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5013",
    "data-name": "Grupo 5013",
    transform: "translate(16.884 9.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5012",
    "data-name": "Grupo 5012",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2299",
    "data-name": "Ret\\xE2ngulo 2299",
    width: 24.574,
    height: 61.887,
    transform: "translate(-0.118 0)",
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5015",
    "data-name": "Grupo 5015",
    transform: "translate(44.074 40.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5014",
    "data-name": "Grupo 5014",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2300",
    "data-name": "Ret\\xE2ngulo 2300",
    width: 31.365,
    height: 31.314,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5017",
    "data-name": "Grupo 5017",
    transform: "translate(42.675 47.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5016",
    "data-name": "Grupo 5016",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2301",
    "data-name": "Ret\\xE2ngulo 2301",
    width: 12.991,
    height: 24.352,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5019",
    "data-name": "Grupo 5019",
    transform: "translate(64.049 47.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5018",
    "data-name": "Grupo 5018",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2302",
    "data-name": "Ret\\xE2ngulo 2302",
    width: 12.925,
    height: 24.296,
    transform: "translate(-0.147 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon60StationsWhite);
export default __webpack_public_path__ + "static/media/icon-60-stations-white.025ee3a5d957873c115a748d765c4533.svg";
export { ForwardRef as ReactComponent };